export class matrizTransicionEntity {
  InstitucionId: number;
  Periodo: number;
  PeriodoAnterior: number;
  NDatos: number;
  TipoCreditoId: number;
  BnIntereses: boolean;
  ZonaId: number;
  ProductoId: number;
  SectorId: number;
  SucursalId: number;
  AsesorId: number;
}
export class matrizClickEntity {
  InstitucionId: number;
  Periodo: number;
  PeriodoAnterior: number;
  PAR: number;
  BnPAR_Inclusive: number;
  CategoriaCreditoId_Actual: number;
  CategoriaCreditoId_Anterior: number
}
export class matrizFiltroEntity {
  InstitucionId: number;
  Periodo: number;
  PeriodoAnterior: number;
  ZonaId: number;
  ProductoId: number;
  SectorId: number;
  SucursalId: number;
  AsesorId: number;
  BnIntereses: boolean;
}
export class perdidaEntity {
  InstitucionId: number;
  Periodo: number;
  NPeriodosHst: number;
  NPeriodos: number;
  ZonaId: number;
  ProductoId: number;
  SucursalId: number;
  BnIntereses: boolean;
}
export class exposicionEntity {
  InstitucionId: number;
  Periodo: number;
  NPeriodosHst: number;
  NPeriodos: number;
  BnIntereses: boolean;
  TipoCreditoId: number;
  ZonaId: number;
  ProductoId: number;
  SucursalId: number;
}

export class categoriaCreditoEntity{
  InstitucionId: number;
}

export class cosechaEntity {
  InstitucionId: number | undefined;
  Periodo: number | undefined;
  PAR: number | undefined;
  BnPAR_Inclusive: number | undefined;
  // BnConIntereses: number;
  NPeriodosHst: number | undefined;
  ZonaId: number | undefined;
  ProductoId: number | undefined;
  SectorId: number | undefined;
  SucursalId: number | undefined;
  AsesorId: number | undefined;
}
export class cosechaClickEntity {
  InstitucionId: number | undefined;
  Periodo: number | undefined;
  PeriodoCosecha: number | undefined;
  PAR: number | undefined;
  BnPAR_Inclusive: number;
  // BnConIntereses: number | undefined;
}

export class concentracionEntity {
  InstitucionId: number | undefined;
  Periodo: number | undefined;
  ElementoAgrupador: string | undefined;
  NDatosLimite: number | undefined;
  NPeriodos : number | undefined;
  // BnIntereses : number |undefined;
}
export class periodosEntity {
  InstitucionId: number | undefined;
}
export class mayoresDeudoresEntity {
  InstitucionId: number | undefined;
  Periodo: number | undefined;
  NDatosLimite: number | undefined;
  // BnIntereses: number | undefined;
  BnAgruparDatos: number | undefined;
}
export class GraficaPedidaEntity{
  periodo: string;
  perdidaesperada: number;
  perdidanoesperada: number;
  var90: number;
}
export class zonaEntity{
  ZonaId: number;
  InstitucionId: number | undefined;
}
export class sucursalEntity{
  SucursalId: number;
  InstitucionId: number | undefined;
}
export class productoEntity{
  ProductoId: number;
  InstitucionId: number | undefined;
}
export class sectorEntity{
  SectorId: number;
  InstitucionId: number | undefined;
}
export class asesorEntity{
  AsesorId: number;
  InstitucionId: number | undefined;
}